module.exports = __webpack_public_path__ + "static/footer-6-f6c59fd005ec9b553184645848cecd6f.jpg";